// extracted by css-extract-rspack-plugin
export default {"back":"back-mDDsup","footer":"footer-HCHFmL","startOver":"startOver-D5HmnI","confirmPopover":"confirmPopover-OnMKFG"};